import React from "react";
import Lessons from "../components/lessons-list";
import { StudentProfile } from "../../user/ui/components/StudentProfile";
import { StudentMentorsList } from "../../student/ui/components/StudentMentorsList";
import { roles } from "../../../app/routes/paths";
import { useAppRole } from "../../../app/routes/useRolePath";
import { MyLessonsPanel } from "../../lesson";

export const Home = () => {
    const role = useAppRole();

    return (
        <div className='student-container'>
            <div className='student-navbar'>
                <StudentProfile />
                {role === roles.MENTOR && <MyLessonsPanel variant="dashboard" />}
            </div>
            <div className='student-board'>
                {/* <Lessons></Lessons> */}
                {role !== roles.MENTOR && <StudentMentorsList />}
            </div>
        </div>
    );
};

export default Home;
